import { render, staticRenderFns } from "./create-workflow-item.vue?vue&type=template&id=20f0442f&scoped=true&"
import script from "./create-workflow-item.vue?vue&type=script&lang=js&"
export * from "./create-workflow-item.vue?vue&type=script&lang=js&"
import style0 from "./create-workflow-item.vue?vue&type=style&index=0&id=20f0442f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20f0442f",
  null
  
)

export default component.exports